import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "view-tenant-review-header w-100 d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center view-tenant-review-content w-100" }
const _hoisted_3 = { class: "profile-info w-100" }
const _hoisted_4 = { class: "d-flex align-items-center rating" }
const _hoisted_5 = { class: "name mb-0" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_7 = { class: "fs-5 fw-bolder rating-text" }
const _hoisted_8 = { class: "text-normal" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between other-details w-100" }
const _hoisted_11 = { class: "d-flex align-items-center type" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-user icon" }, null, -1)
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center phone"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt icon" }, null, -1)
const _hoisted_16 = { class: "text" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "d-flex align-items-center mail" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope icon" }, null, -1)
const _hoisted_21 = { class: "text" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "text" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Signed up date: ")
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Last Login date: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Avatar, {
        size: 64,
        imageFile: _ctx.tenantAvatarSrc,
        acronym: _ctx.tenantAcronym,
        useIcon: false,
        fontSize: `2em`
      }, null, 8, ["imageFile", "acronym"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.fullName), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, { class: "mb-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_rate, {
                  disabled: "",
                  size: "small",
                  class: "rating-size",
                  "model-value": parseFloat(_ctx.averageRating)
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.rate) + "/5.0 (", 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.reviewsCount), 1),
              _hoisted_9
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.tenantRole), 1)
          ]),
          (_ctx.mobileNumber != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, [
                  (_ctx.mobileNumber != '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `tel: ${_ctx.mobileNumber}`
                      }, _toDisplayString(_ctx.formattedMobileNo), 9, _hoisted_17))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.formattedMobileNo), 1))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("span", _hoisted_21, [
              _createElementVNode("a", {
                href: `mailto: ${_ctx.currentTenant.email}`
              }, _toDisplayString(_ctx.currentTenant.email), 9, _hoisted_22)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.formatDate(_ctx.currentTenant.signup_date, 'aus')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("strong", null, _toDisplayString(_ctx.lastLoggedInDate), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}